const APP_PATH = 'app';
const API_URL = "/api";

const USER_COOKIE = 'yacht-calendar';

const USER_ROLES = [
    'User',
    'Admin',
    'Agent',
];

const USER_ROLE = {
    USER: 0,
    ADMIN: 1,
    AGENT: 2,
}

const WEEKDAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const RESERVATION_STATUS = {
    NEW: 0,
    ACTIVE: 1,
    CANCELED: 2,
}

const RESERVATION_STATUSES = [
    'New',
    'Active',
    'Canceled'
];

export {
    APP_PATH,
    API_URL,
    USER_COOKIE,
    USER_ROLES,
    USER_ROLE,
    WEEKDAYS,
    MONTHS,
    RESERVATION_STATUS,
    RESERVATION_STATUSES
}